import { FormattedMessage, useIntl } from 'react-intl';
import Modal from 'components/modal/Modal';
import { CardHeader, CardHeaderTitle } from 'components/card/card-header';
import { CardBody, CardFooter } from 'components/card';
import FieldInput from 'components/input/FieldInput';
import messages from 'messages';
import { Button, ButtonsGroup } from 'components/button';
import { ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION_EXERCISES } from 'routes/RouteList';
import { useNotificationQueue } from 'components/notification';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import Template from 'models/Template';
import { TemplateType } from 'constants.js';
import CollectionForm from 'containers/pages/exercises/collections/CollectionForm';

function AddCollectionModal({ onClose }) {
  const { push } = useHistory();
  const intl = useIntl();
  const notification = useNotificationQueue();

  const { entityId, tab } = useParams();

  const onCloseHandler = () => {
    if (onClose) onClose();
  };

  return (
    <Modal card autoHeight isOpen={true} onClose={onCloseHandler}>
      <CardHeader modal>
        <CardHeaderTitle>
          <FormattedMessage {...messages.collectionsAddTitle} />
        </CardHeaderTitle>
      </CardHeader>
      <CollectionForm
        entityId={entityId}
        template={new Template({ type: TemplateType.COLLECTION })}
        type={TemplateType.COLLECTION}
        onComplete={async templateId => {
          notification.add(templateId, {
            message: intl.formatMessage(messages.messageAddCollectionSuccess)
          });
          setTimeout(() => {
            push(
              generatePath(
                ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION_EXERCISES,
                {
                  entityId,
                  tab,
                  templateId
                }
              )
            );
          }, 100);
          onClose && onClose();
        }}
      >
        {({ errors, touched, isSubmitting }) => (
          <>
            <CardBody modalWithOverflow>
              <FieldInput
                id="title"
                name="title"
                placeholder={intl.formatMessage(messages.collectionNameLabel)}
                errors={errors}
                touched={touched}
                required
              >
                <FormattedMessage {...messages.collectionNameLabel} />
              </FieldInput>
            </CardBody>
            <CardFooter modal extraClassNames="c-card__footer--modal-larger">
              <ButtonsGroup>
                <Button secondary onClick={() => onCloseHandler()}>
                  <FormattedMessage {...messages.buttonCancel} />
                </Button>
                <Button type="submit" primary disabled={isSubmitting}>
                  <FormattedMessage {...messages.buttonSave} />
                </Button>
              </ButtonsGroup>
            </CardFooter>
          </>
        )}
      </CollectionForm>
    </Modal>
  );
}

export default AddCollectionModal;
